import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  IconButton,
  RouteWrapper,
  HeadingSection,
  PendingAccountPaymentTable,
  Section,
} from '../../components';
import { getCompany } from '../../redux/actions/companies';
import { getPendingAccountsExportCsv } from '../../redux/actions/payments';

interface Props {
  dispatch: any;
  match: any;
}

interface State {
  company: any;
}

class Route extends React.Component<Props, State> {
  state = {
    company: null,
  };

  async componentDidMount() {
    if (this.props.match.params.company_id) {
      const { error, data } = await this.props.dispatch(
        getCompany(this.props.match.params.company_id),
      );
      if (!error) {
        this.setState({ company: data });
      }
    }
  }

  render() {
    return (
      <RouteWrapper
        title="Pending Accounts"
        requireAuth
        requirePermission="MANAGE_PAYMENTS"
        breadcrumbs={
          this.state.company
            ? [
                {
                  link: '/payments/pending-account',
                  text: 'Pending Accounts',
                },
                {
                  link: `/payments/pending-account/${this.state.company.id}`,
                  text: this.state.company.name,
                },
              ]
            : []
        }
      >
        <HeadingSection
          title={`Pending Accounts${
            this.state.company ? ` for ${this.state.company.name}` : ''
          }`}
          controls={[
            ...(!this.props.match.params.company_id
              ? [
                  <IconButton
                    key="back-button"
                    icon="download"
                    className="is-default"
                    handleClick={async (target) => {
                      const response = await this.props.dispatch(
                        getPendingAccountsExportCsv(),
                      );
                      if (!response.error) {
                        const data = `data:text/plain;charset=utf-8,${encodeURIComponent(
                          response.data,
                        )}`;
                        const a: HTMLAnchorElement = document.createElement(
                          'a',
                        );
                        a.setAttribute('href', data);
                        a.setAttribute(
                          'download',
                          `pending-accounts-${new Date().toDateString()}.csv`,
                        );
                        document.querySelector('body').appendChild(a);
                        a.click();
                        document.querySelector('body').removeChild(a);
                      }
                    }}
                  >
                    Export
                  </IconButton>,
                ]
              : []),

            <IconButton
              key="pending-account"
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <PendingAccountPaymentTable
            company_id={this.props.match.params.company_id}
          />
        </Section>
      </RouteWrapper>
    );
  }
}

export default connect()(Route);
